import { OperationState } from "@/@types/vuex";

export default {
  operations: {},
} as OperationState;
